import * as React from 'react';
import { BuilderBlocks, BuilderElement } from '@builder.io/react';
import { Tabs as DSTabs } from '@/components/shared';
import { TabsComponentProps } from './register';

export interface TabsProps extends TabsComponentProps {
	readonly builderBlock: BuilderElement;
}

/**
 * CMS Tabs component, used for showing CMS content in tabs
 */
export const Tabs: React.FunctionComponent<TabsProps> = ({ tabs, builderBlock }) => {
	if (!tabs) return null;

	return (
		<DSTabs>
			{tabs.map((tab, index) => (
				<DSTabs.Panel name={tab.label} key={tab.label}>
					<BuilderBlocks
						key={index}
						parentElementId={builderBlock && builderBlock.id}
						dataPath={`component.options.tabs.${index}.content`}
						child
						blocks={tab.content}
					/>
				</DSTabs.Panel>
			))}
		</DSTabs>
	);
};
